var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGoogleAuth = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89996 29.9797C8.89996 43.511 19.0735 50.0776 25.4565 52.8658C27.188 53.6222 28.0537 54.0004 30.5 54.0004V20.4004L8.89996 27.6004V29.9797Z",
    fill: "#4FC814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.5435 52.8658C41.9266 50.0776 52.1001 43.511 52.1001 29.9797V27.6004L30.5001 20.4004V54.0004C32.9463 54.0004 33.812 53.6222 35.5435 52.8658Z",
    fill: "#4FC814"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.9105 7.93132L21.5357 8.4019C14.3199 10.8719 10.712 12.1069 9.806 13.3978C8.89996 14.6887 8.89996 18.5258 8.89996 26.2V27.6L30.5 20.4V6C28.5526 6 26.6719 6.64377 22.9105 7.93132Z",
    fill: "#4FC814"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4643 8.4019L38.0895 7.93132C34.3281 6.64377 32.4474 6 30.5001 6V20.4L52.1001 27.6V26.2C52.1001 18.5258 52.1001 14.6887 51.194 13.3978C50.288 12.1069 46.6801 10.8719 39.4643 8.4019Z",
    fill: "#4FC814"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleAuth, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GoogleAuth.2aece863.svg";
export { ForwardRef as ReactComponent };